import { connect } from 'react-redux';
import {
  changeDimensionType,
  changeFirstEvent,
  changeReturnEvent,
} from '../../../actions/retention/retention';
import RetentionSimplifiedComposeContainer from '../../../components/retention/simple/RetentionSimplifiedComposeContainer';
import { getRetentionDimensionType } from '../../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  selectedDimensionType: getRetentionDimensionType(state),
});

const mapDispatchToProps = {
  onDimensionTypeChange: changeDimensionType,
  onFirstEventChange: changeFirstEvent,
  onReturnEventChange: changeReturnEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(RetentionSimplifiedComposeContainer);
